import { Container, Row, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import logo from '../Assets/logo.png';

const NewHome = ()=>{
    const navigate = useNavigate();
    return(
        <>
            <Container fluid style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center" style={{width:"100%"}}>
                        <Card.Img variant="top" src={logo} style={{width:"25%", alignSelf:"center", paddingTop:"20px"}}/>
                    </Row>
                    <Row className="justify-content-center" style={{width:"100%", marginTop:0}}>
                        <Row className="justify-content-center">DASHBOARDS</Row>
                        <Row className="justify-content-center" style={{marginTop:10}}>
                            <ol style={{width:520, textAlign:'left'}}>
                                <li
                                    style={{cursor:'pointer'}}
                                    onClick={()=>{
                                        navigate("/service");
                                    }}
                                >
                                    Service Requests and Repairs
                                </li>
                                <li
                                    style={{cursor:'pointer', marginTop:10}}
                                    onClick={()=>{
                                        navigate("/maintenance");
                                    }}
                                >
                                    Maintenance
                                </li>
                                <li
                                    style={{cursor:'pointer', marginTop:10}}
                                    onClick={()=>{
                                        navigate("/construction");
                                        // alert('Install and Construction - Future');
                                    }}
                                >
                                    Install and Construction - Future
                                </li>
                            </ol>
                        </Row>
                        <Row className="justify-content-center" style={{marginTop:20}}>EXTERNAL QUICK LINKS</Row>
                        <Row className="justify-content-center" style={{marginTop:10}}>
                            <ol style={{width:520, textAlign:'left'}}>
                                <li
                                    style={{cursor:'pointer'}}
                                    onClick={()=>{
                                        navigate("/userguide");
                                    }}
                                >
                                    User Guide (under construction)
                                </li>
                            </ol>
                        </Row>
                        <Row className="justify-content-center" style={{width:"100%", fontSize:'0.75em', marginTop:60}}>
                            ~ Select a Dashboard from the list or side menu ~
                        </Row>
                    </Row>
                </Container>
            </Container>
        </>
    )
}

export default NewHome;